import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'

class DetailBloc {

    updateChannel = new Subject()
    repository = new DetailRepository()
    detailStankomChannel = new Subject();
    kompetensiChannel = new Subject();
    kompetensiLevelChannel = new Subject();

    constructor() {
        this.updateChannel.next({ status: apiResponse.INITIAL })
        this.detailStankomChannel.next({status: apiResponse.INITIAL})
        this.kompetensiChannel.next({status: apiResponse.INITIAL})
        this.kompetensiLevelChannel.next({status: apiResponse.INITIAL})
    }

    fetchUpdate = async (query) => {
        this.updateChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.updateChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchDetailStankom = async (query) => {
        this.detailStankomChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchDetailStankom(query).then((result) => {
                this.detailStankomChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailStankomChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
    fetchKompetensiList = async (query) => {
        this.kompetensiChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchKompetensiList(query).then((result) => {
                this.kompetensiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.kompetensiChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
    fetchKompetensiLevel = async (query) => {
        this.kompetensiLevelChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchKompetensiLevel(query).then((result) => {
                this.kompetensiLevelChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.kompetensiLevelChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }

}

export default DetailBloc
